export default {"src":"/_next/static/media/Vector.b92d2bc3.svg","height":20,"width":18};